export enum RepresentativePresenceTypes {
    OWN = "OWN",
    NO = "NO",
}
